import { render, staticRenderFns } from "./Additional-products.vue?vue&type=template&id=ed614a5a"
import script from "./Additional-products.vue?vue&type=script&lang=js"
export * from "./Additional-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports